import React from "react";
import Form, { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import { LoadIndicator } from "devextreme-react/load-indicator";
import Button from "devextreme-react/button";
import PaginaToolbar from "../components/PaginaToolbar";
import DataGrid, { Column, Paging, Pager } from "devextreme-react/data-grid";
import notify from "devextreme/ui/notify";
import uiInfo from "../ui-info";

const template = {
  exercicio: undefined,
  dataCriacao: undefined,
  livro: undefined,
  tipo: 0,
};

export default class GerarLivro extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...template,
      loading: false,
    };

    this._gridInstance = React.createRef();
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.gerarLivro = this.gerarLivro.bind(this);

    this.tipoOptions = {
      dataSource: [
        { id: 0, descricao: "Nenhum" },
        { id: 1, descricao: "Imobiliário" },
        { id: 2, descricao: "Mobiliário" },
        { id: 3, descricao: "Não Tributário" },
      ],
      placeholder: "Escolher...",
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  componentDidMount() {
    this.setState({ ...template });
  }

  gerarLivro() {
    notify("Gerando....", "success", 1000);
    //this.setState({ ...this.state, loading: false });
  }

  render() {
    return (
      <React.Fragment>
        <h3 style={{ marginLeft: "5%" }}>Gerar Livro</h3>
        <div className={"content-block dx-card responsive-paddings"}>
          {this.state.loading ? (
            <LoadIndicator
              id="large-indicator"
              height={60}
              width={60}
              visible={this.state.loading}
            />
          ) : (
            <form>
              <Form
                formData={this.state}
                colCount={1}
                ref={this.formRef}
                labelLocation="top"
                onFieldDataChanged={this.formFieldDataChanged}
              >
                <GroupItem colSpan={4} colCount={4}>
                  <SimpleItem dataField="exercicio">
                    <Label text="Exercício" />
                  </SimpleItem>
                  <SimpleItem
                    editorType={"dxDateBox"}
                    dataField="dataCriacao"
                    editorOptions={{
                      width: "100%",
                    }}
                  >
                    <Label text="Data de Criação" />
                  </SimpleItem>
                  <SimpleItem dataField="livro" editorType="dxNumberBox" />
                  <SimpleItem
                    editorType={"dxSelectBox"}
                    dataField="tipo"
                    editorOptions={this.tipoOptions}
                  >
                    <Label text="Tipo" />
                  </SimpleItem>
                </GroupItem>
              </Form>
              <div style={{ marginTop: "20px" }}>
                <div style={{ display: "inline-block" }}>
                  <Button
                    width={120}
                    text="Gerar Livro"
                    type="success"
                    onClick={() => {
                      this.setState({ loading: true }, this.gerarLivro);
                    }}
                  />
                </div>
              </div>
            </form>
          )}
          <br />
          <br />
          <PaginaToolbar titulo="Livros" ocultarNovo={true}>
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              //dataSource={this.previsaoGrade}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              focusedRowEnabled={false}
              allowColumnReordering={true}
            >
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  {
                    text: "Visualizar",
                    visible: this.usadoComoPesquisa,
                    onClick: this.onSelecionado,
                  },
                ]}
              />
              <Column
                dataField={"exercicio"}
                caption={"Exercício"}
                showInColumnChooser={false}
              />
              <Column dataField={"tipo"} showInColumnChooser={false} />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }
}
